module.exports = __webpack_public_path__ + "870e61b40c09f79cdc2649adcce7784a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-panel-320.jpg
// module id = 341
// module chunks = 0